import { render, staticRenderFns } from "./ListViewBaseItem.vue?vue&type=template&id=31de91f3&scoped=true&"
import script from "./ListViewBaseItem.vue?vue&type=script&lang=js&"
export * from "./ListViewBaseItem.vue?vue&type=script&lang=js&"
import style0 from "./ListViewBaseItem.vue?vue&type=style&index=0&id=31de91f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de91f3",
  null
  
)

export default component.exports